import { Box, BoxProps, useMediaQuery } from "@chakra-ui/react"
import IconButton, {
  Indicator
} from "@pathwright/ux/src/components/button/IconButton"
import Link from "@pathwright/ux/src/components/link/Link"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { PendingReviewCountItem, useHomeContext } from "../HomeContext"

function getInboxTo(item: PendingReviewCountItem) {
  switch (item.__typename) {
    case "Registration":
      return `/inbox?filter=pending&order=asc&cohort_id=${item.group.id}&ui_selected_parent=${item.group.id}`
    case "MentorGroupMembership":
      return `/inbox?filter=pending&order=asc&group_id=${item.group.id}&ui_selected_parent=${item.group.id}`
    default:
      return "/inbox"
  }
}

// Simple wrapper to get item's pending review count from context.
function usePendingReviewCount(item: PendingReviewCountItem) {
  const { getPendingReviewCount } = useHomeContext()
  return getPendingReviewCount(item)
}

export function PendingReviewCountIndicator({
  item
}: {
  item: PendingReviewCountItem
}) {
  const pendingReviewCount = usePendingReviewCount(item)
  const [hasHover] = useMediaQuery(["(hover: hover)"])

  return pendingReviewCount ? (
    <Indicator
      // Hide on hover / never show on mobile.
      opacity={hasHover ? 1 : 0}
      _groupHover={{ opacity: 0 }}
      transition="opacity .2s ease"
    />
  ) : null
}

function PendingReviewCount({
  item,
  hideOnHover = true
}: {
  item: PendingReviewCountItem
  hideOnHover?: boolean
}) {
  const pendingReviewCount = usePendingReviewCount(item)
  const [hasHover] = useMediaQuery(["(hover: hover)"])

  const hoverProps: BoxProps = hideOnHover
    ? {
        // Show on hover / always show on mobile.
        opacity: hasHover ? 0 : 1,
        _groupHover: { display: "inline-flex", opacity: 1 },
        transition: "opacity .2s ease"
      }
    : {}

  return pendingReviewCount ? (
    <Box {...hoverProps}>
      <IconButton
        asChild
        aria-label="Inbox Pending Review Count"
        roundSize={6}
        indicator
        variant="solid"
        colorPalette="whiteAlpha"
      >
        <Link to={getInboxTo(item)}>
          <Pathicon icon="inbox" />
        </Link>
      </IconButton>
    </Box>
  ) : null
}

export default PendingReviewCount
